<template>
    <div class="container mt-3 ml-1 text-dark">
        <div class="modal fade" id="add_employee" tabindex="-1" role="dialog" aria-labelledby="add_employee_label" data-backdrop="static" data-keyboard="false" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header" style="border-bottom: 0px;">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <i class='fas fa-times text-muted'></i>
                        </button>
                    </div>
                    <div class="modal-body container">
                        <div class="form-group">
                            <label for="searchUsers" class="font-weight-bold">Medewerker toevoegen aan <span class="text-secondary">{{ departmentName }}</span></label>
                            <Select2 id="searchUsers"
                                :options="users"
                                :settings="{
                                    width: '100%',
                                    placeholder: 'Zoek een werknemer',
                                }"
                                @select="addUser"
                            />
                        </div>
                        <div class="form-group">
                            <label class="font-weight-bold">Geselecteerde medewerkers</label>
                            <ul class="list-group card rounded" style="height: 125px; overflow: auto; border: solid 1px #c2c2c2;">
                                <li v-for="(user) of selectedUsers" v-bind:key="user.id" class="list-group-item" style="border: none;">
                                    <div class="col-12 row m-0 p-0">
                                        <span class="col-11 p-0">{{ user.text }}</span> <i class='fas fa-times text-muted col-1 p-0' style="top: 5px;" @click="removeUser(user.id)"></i>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="saveUsersToDepartment">Toevoegen</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Select2 from 'vue3-select2-component';

    export default {
        components: {
            Select2,
        },
        props: {
            departmentName: String,
            selectedDepartment: Number
        },
        data: function () {
            return {
                users: [],
                selectedUsers: [],
            }
        },
        watch: {
            selectedDepartment: {
                handler: function () {
                    this.getUsers();
                },
            }
        },
        beforeMount() {
            this.getUsers();
        },
        emits: ['added-employees'],
        methods: {
            /**
             *
             * Get data
             *
             */
            getUsers() {
                $.ajax({
                    type : 'GET',
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    dataType: 'json',
                    url : `get-users`,
                    data:{
                        excludeDepartment: this.selectedDepartment,
                    },
                    success: this.setUsers,
                });
            },
            /**
             *
             * Events
             *
             */
            setUsers(event) {
                this.users = [];

                Object.entries(event.users).forEach(([index, data]) => {
                    this.users.push({id: index, profile_id: data.profileId, text: data.fullName})
                });

                this.users.sort(this.compare);
            },
            saveUsersToDepartment() {
                $.ajax({
                    type : 'POST',
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    dataType: 'json',
                    url : `save-employees`,
                    data:{
                        id: this.selectedDepartment,
                        users: this.selectedUsers
                    },
                    success: this.callBackSavedEmployees,
                });
            },
            addUser(event){
                // Find the newly added user
                let addedUser = this.users.filter((user) => {
                    return user.id === event.id;
                });

                // Re add all users, except the just added user
                this.users = this.users.filter((user) => {
                    return user.id !== event.id;
                });

                this.selectedUsers.push(addedUser[0])
                this.selectedUsers.sort(this.compare);
            },
            removeUser(id) {
                // Find the removed selected user
                let removedUser = this.selectedUsers.filter((user) => {
                    return user.id === id;
                });

                // Re add all selected users, except the just removed user
                this.selectedUsers = this.selectedUsers.filter((user) => {
                    return user.id !== id;
                });

                this.users.push(removedUser[0]);
                this.users.sort(this.compare);
            },
            /**
             *
             * Callbacks
             *
             */
            callBackSavedEmployees() {
                document.getElementById('add_employee').classList.remove('show');
                this.selectedUsers = [];

                this.$emit('added-employees');
            },
            /**
             *
             * Sorting
             *
             */
            compare(value1, value2) {
                if (value1.text < value2.text){
                    return -1;
                }
                if (value1.text > value2.text){
                    return 1;
                }
                return 0;
            },
        },
    }
</script>
